function n() {
  var n = new Map();
  return {
    on: function on(t, e) {
      var f = n.get(t);
      f ? f.push(e) : f = [e], n.set(t, f);
    },
    off: function off(t, e) {
      var f = n.get(t);
      f.splice(f.indexOf(e) >>> 0, 1);
    },
    emit: function emit(t, e) {
      var f = n.get(t);
      f && f.slice().forEach(function (n) {
        return n(e);
      });
    }
  };
}
export { n as default };